import { Component, OnInit, Input } from '@angular/core';
import { Device } from '../../devices.model_new';
import { ClimatizationDeviceTypesMap, ClimatizationDeviceType } from '../../devices.constant';

@Component({
  selector: 'app-climatization-detail',
  templateUrl: './climatization-detail.component.html',
  styleUrls: ['./climatization-detail.component.scss']
})

export class ClimatizationDetailComponent implements OnInit {
@Input()
device: Device;
ClimatizationDeviceType = ClimatizationDeviceType;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/devices/device-detail/climatization-detail/climatization-detail.component.ts